import { css } from 'lit';

export const CSS_BASE_CONTENT_WIDTH = css`500px`;
